module.exports = __webpack_public_path__ + "files/ecbb9fac8f3b53ae4e6aa1e2e911f310.png";